import { combineReducers } from 'redux'
import cly_holding_limit_reducer from './masters/cly_holding_limit_reducer'
import customer_reducer from './masters/customer_reducer'
import cylinder_reducer from './masters/cylinder_reducer'
import industry_reducer from './masters/industry_reducer'
import unit_reducer from './masters/unit_reducer'
import depot_reducer from './masters/depot_reducer'
import rate_reducer from './masters/rate_reducer'
import rm_reducer from './masters/rm_reducer'
import account_manager_reducer from './masters/account_manager_reducer'
import uom_conversion_reducer from './masters/uom_conversion_reducer'
import uom_reducer from './masters/uom_reducer'
import delivery_challan_reducer from './transactions/delivery_challan_reducer'
import supplier_reducer from './masters/supplier_reducer'
import driver_reducer from './masters/driver_reducer'
import product_reducer from './masters/product_reducer'
import schedule_entry_reducer from './productionEntries/schedule_entry_reducer'
import grn_reducer from './transactions/grn_reducer'
import customer_po_reducer from './transactions/sales_order_reducer'
import production_planning_reducer from './productionEntries/production_planning_reducer'
import cylinder_inward_reducer from './storeEntries/cylinder_inward_reducer'
import bom_reducer from './utility/bom_reducer'
import customer_type_reducer from './masters/customer_type_reducer'
import cylinder_status_reducer from './masters/cylinder_status_reducer'
import production_entry_reducer from './productionEntries/production_entry_reducer'
import quality_entry_reducer from './productionEntries/quality_entry_reducer'
import delivery_order_reducer from './transactions/delivery_order_reducer'
import location_reducer from './masters/location_reducer'
import customer_product_reducer from './masters/customer_product_reducer'
import customer_category_reducer from './masters/customer_category'
import eci_reducer from './storeEntries/eci_reducer'
import internal_movement_reducer from './storeEntries/internal_movement_reducer'
import vehicle_reducer from './masters/vehicle_reducer'
import route_reducer from './masters/route_reducer'
import user_reducer from './masters/user_reducer'
import login_reducer from "./utility/login_reducer"
import cylinder_tag_mapping_reducer from"./masters/cylinder_tag_mapping_reducer"
import delivery_challan_customer_reducer from './transactions/delivery_challan_customer_reducer'


export default combineReducers({
    cly_holding_limit: cly_holding_limit_reducer,
    customer: customer_reducer,
    cylinder: cylinder_reducer,
    industry: industry_reducer,
    unit: unit_reducer,
    depot:depot_reducer,
    rate: rate_reducer,
    rm: rm_reducer,
    account_manager: account_manager_reducer,
    uom_conversion: uom_conversion_reducer,
    uom: uom_reducer,
    delivery_challan: delivery_challan_reducer,
    delivery_order: delivery_order_reducer,
    supplier: supplier_reducer,
    driver: driver_reducer,
    product: product_reducer,
    schedule_entry: schedule_entry_reducer,
    grn: grn_reducer,
    customer_po: customer_po_reducer,
    production_planning:production_planning_reducer,
    production_entry:production_entry_reducer,
    quality_entry:quality_entry_reducer,
    cylinder_inward:cylinder_inward_reducer,
    bom: bom_reducer,
    customerType:customer_type_reducer,
    customerCategory:customer_category_reducer,
    cylinder_status:cylinder_status_reducer,
    location:location_reducer,
    cpd: customer_product_reducer,
    eci:eci_reducer,
    internal_movement: internal_movement_reducer,
    vehicle:vehicle_reducer,
    route:route_reducer,
    user:user_reducer,
    login:login_reducer,
    cylinder_tag_mapping:cylinder_tag_mapping_reducer,
    delivery_challan_customer:delivery_challan_customer_reducer,
 
   

})